import { useState } from "react";
import {
    Box,
    Button,
    Collapsible,
    HStack,
    IconButton,
    Input,
    Select,
    VStack,
    Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { HiStar, HiChevronDown } from "react-icons/hi2";
import DateInput from "./DateInput";

const MobileFiltersPanel = ({
    searchQuery,
    onSearchChange,
    statusFilter,
    onStatusChange,
    statusCollection,
    showFavoriteOnly,
    onFavoriteToggle,
    createdFrom,
    onCreatedFromChange,
    createdTo,
    onCreatedToChange,
}) => {
    const { t } = useTranslation("models");
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Box display={{ base: "block", md: "none" }} w="full">
            <Collapsible.Root open={isOpen} onOpenChange={(e) => setIsOpen(e.open)}>
                <HStack gap={2}>
                    <Collapsible.Trigger asChild>
                        <Button variant="outlined" size="sm" flex={1}>
                            <HStack justify="space-between" w="full">
                                <Text fontSize="sm">{t("recruitmentDetailPage.filtersButton")}</Text>
                                <Box
                                    transform={isOpen ? "rotate(180deg)" : "none"}
                                    transition="transform 0.2s"
                                >
                                    <HiChevronDown />
                                </Box>
                            </HStack>
                        </Button>
                    </Collapsible.Trigger>
                    <IconButton
                        variant="ghost"
                        size="sm"
                        aria-label="showFavoriteOnly"
                        color={showFavoriteOnly ? "yellow.400" : "gray.500"}
                        onClick={onFavoriteToggle}
                        flexShrink={0}
                    >
                        <HiStar />
                    </IconButton>
                </HStack>

                <Collapsible.Content>
                    <VStack w="full" gap={3} pt={3} align="stretch">
                        <Input
                            placeholder={t("recruitmentDetailPage.searchPlaceholder")}
                            value={searchQuery}
                            onChange={(e) => onSearchChange(e.target.value)}
                            size="md"
                            bg="bg.card"
                            border="1px solid"
                            borderColor="border.primary"
                            borderRadius="md"
                            color="white"
                            _placeholder={{ color: "text.grey" }}
                        />
                        <HStack gap={2} w="full">
                            <DateInput
                                placeholder={t("candidatePage.filterCreatedFrom")}
                                value={createdFrom ?? ""}
                                onChange={(e) => onCreatedFromChange(e.target.value)}
                                size="md"
                                bg="bg.card"
                                border="1px solid"
                                borderColor="border.primary"
                                borderRadius="md"
                                color="white"
                                _placeholder={{ color: "text.grey" }}
                                flex={1}
                            />
                            <DateInput
                                placeholder={t("candidatePage.filterCreatedTo")}
                                value={createdTo ?? ""}
                                onChange={(e) => onCreatedToChange(e.target.value)}
                                size="md"
                                bg="bg.card"
                                border="1px solid"
                                borderColor="border.primary"
                                borderRadius="md"
                                color="white"
                                _placeholder={{ color: "text.grey" }}
                                flex={1}
                            />
                        </HStack>
                        <Select.Root
                            collection={statusCollection}
                            value={statusFilter}
                            onValueChange={(e) => onStatusChange(e.value)}
                            multiple
                            size="sm"
                            w="full"
                        >
                            <Select.HiddenSelect />
                            <Select.Control>
                                <Select.Trigger
                                    bg="bg.card"
                                    border="1px solid"
                                    borderColor="border.primary"
                                    borderRadius="md"
                                    fontSize="sm"
                                    color="white"
                                >
                                    <Select.ValueText color="white" placeholder={t("candidateStatus.all")} />
                                </Select.Trigger>
                                <Select.IndicatorGroup>
                                    <Select.Indicator color="white" />
                                </Select.IndicatorGroup>
                            </Select.Control>
                            <Select.Positioner>
                                <Select.Content bg="bg.card" borderColor="border.primary">
                                    {statusCollection.items.map((opt) => (
                                        <Select.Item item={opt} key={opt.value} color="white">
                                            {opt.label}
                                            <Select.ItemIndicator />
                                        </Select.Item>
                                    ))}
                                </Select.Content>
                            </Select.Positioner>
                        </Select.Root>
                    </VStack>
                </Collapsible.Content>
            </Collapsible.Root>
        </Box>
    );
};

export default MobileFiltersPanel;
